"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expanderDefaultProps = exports.expanderContentDefaultProps = exports.HEADER_COLOR = exports.FOCUS_OUTLINE_WIDTH = exports.FOCUS_OUTLINE_OFFSET = exports.FOCUS_COLOR = void 0;

var _interfaces = require("./interfaces");

var expanderContentDefaultProps = {
  topSpacing: 0,
  isExpanded: false,
  shouldAnimateImmediately: false,
  shouldAnimate: true
};
exports.expanderContentDefaultProps = expanderContentDefaultProps;
var expanderDefaultProps = {
  shouldExpandOnMount: false,
  shouldAnimate: true,
  contentSpacing: 'S300',
  size: _interfaces.ExpanderSize.Default,
  layout: _interfaces.ExpanderLayout.Default
};
exports.expanderDefaultProps = expanderDefaultProps;
var HEADER_COLOR = 'neutral90';
exports.HEADER_COLOR = HEADER_COLOR;
var FOCUS_COLOR = 'primary70';
exports.FOCUS_COLOR = FOCUS_COLOR;
var FOCUS_OUTLINE_WIDTH = 2;
exports.FOCUS_OUTLINE_WIDTH = FOCUS_OUTLINE_WIDTH;
var FOCUS_OUTLINE_OFFSET = 1;
exports.FOCUS_OUTLINE_OFFSET = FOCUS_OUTLINE_OFFSET;